import { useDispatch } from "react-redux";
import React, { Fragment, useState } from "react";
import { CircularProgress } from "@mui/material";
import _ from "lodash";
import { oEmbedActions, proactiveActions } from "_actions";
import { isTimeToday } from "_helpers";
import { channelTypes } from "_constants";
import { isMetaSourcesForOEmbed } from "../Vote/Sections/BodySection/Conversation/OEmbed/EmbedUtils";
import { formatDateCreated } from "./ProactiveMetricsDetailUtil";
import styles from "./Utilities/styles.module.css";
import useLocationQueryParams from "../../hooks/useLocationQueryParams";

export const ProactiveMessageList = ({
    source,
    organizationId,
    msgList,
    setMessageLink,
    setMessageSource,
    loading,
    channel,
}) => {
    const { params } = useLocationQueryParams()
    const dispatch = useDispatch();
    const [selectedIndex, setSelectedIndex] = useState(null);

    const onMessageSelect = (msg, index) => {
        const msgSourceName = _.toString(channel).toLowerCase();
        setMessageLink(msg.link);
        setMessageSource(msgSourceName);
        setSelectedIndex(index);
        const campaignId = params.campaignIds
        dispatch(proactiveActions.getProactiveMsgConversation(msg.id, organizationId, source, campaignId));

        if (isMetaSourcesForOEmbed(msgSourceName, msg.displayInApp)) {
            dispatch(oEmbedActions.getMetaEmbed(msg.id));
        }
    };

    const isShopify = _.toString(channel).toUpperCase() === channelTypes.shopify;

    if (loading) {
        return (
            <div className={styles.msgListLoaderContainer}>
                <div className={styles.msgListInner}>
                    <CircularProgress sx={{ color: "#003300" }} />
                </div>
            </div>
        );
    }

    if (!Array.isArray(msgList) || msgList.length === 0) {
        return (
            <div className={styles.msgListEmpty}>
                <span>No messages found.</span>
            </div>
        );
    }

    return msgList
        .filter(Boolean)
        .map((msg, i) => (
            <Fragment key={`${msg.id}-${i}`}>
                <div
                    role="button"
                    id={`${msg.id}-${i}`}
                    className={selectedIndex === i ? styles.bgGray : styles.bgWhite}
                    onClick={() => onMessageSelect(msg, i)}
                >
                    <div className="message-list-container">
                        <div className="tms-truncate-2-lines message-list-text">
                            {isShopify ? msg.authorName : msg.text}
                        </div>
                        <div>
                            <div className="message-list-date">
                                {isTimeToday(msg.firstOutgoingMessageDate)
                                    ? formatDateCreated(msg.firstOutgoingMessageDate, "HH:mm a")
                                    : formatDateCreated(msg.firstOutgoingMessageDate, "DD-MMM-YYYY")}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        ));
};